import React from "react";

const TheName = ({lang}) => {

  return (
    <>
     <div className= { lang === false ?"block":"hidden"}>
      <div className="relative px-32 lg:px-16 md:px-14 py-10 lg:py-10 sm:px-2 lg:w-full sm:w-full" id='whous'>
        <div className="absolute left-0 top-0 lg:-mt-[-350px] md:-mt-[-200px] sm:-mt-[-200px]">
          <img src="assets/images/Map2.svg" 
               className="object-fill h-fit xl:w-[55rem] lg:w-[35rem] md:w-[25rem] sm:w-[25rem]"/>
        </div>

        <div className="absolute right-0 bottom-0 xl:-mb-[500px] ">
          <img src="assets/images/Map3.svg" 
               className="object-fill h-fit xl:w-[55rem] lg:w-[35rem] md:w-[25rem] sm:w-[25rem]"/>
        </div>

      <div className="relative section mx-auto p-10 lg:p-1 sm:p-0 lg:w-[82%] sm:w-11/12 xl:max-w-[1400px] xl:mx-auto">
        <div className=" m-auto lg:p-6 p-11 sm:p-6 basis-4/5">
          <div className=" mx-auto text-center relative flex justify-center">
                <h2 className="xl:text-5xl lg:text-4xl sm:text-3xl py-8 mb-8 text-center font-black">لم اسم اللعبة؟</h2>
                <span className="bg-orange lg:w-44 w-40 sm:w-36 h-1  absolute rounded mt-24 lg:mt-28"></span>
            </div>

            <p className="font-black text-center leading-loose xl:text-3xl lg:text-2xl md:leading-10 md:text-2xl lg:px-5 xl:px-44 xl:leading-loose lg:leading-loose  px-40 mb-8 md:mb-0 sm:mb-0 mt-8 md:px-10 sm:text-xl sm:px-2">الاسم منشق عن مفهوم اللوعبة <br/>  اللوعبة هي علم متعارف عليه منذ مطلع القرن العشرين وانحصرت استخداماتها في ألعـاب الفيديو حتى دخلت لأول مرة في حياتنـا عبر علوم التسويق لتحفيز المستهلكين على الشراء أكثر والارتباط بذاك الفعل<br/><br/>لكن كيـف يمكن لشيء معقد كالحيـاة أن يكـون لعبـة وكيف يمكن تطبيقـه؟ببساطـة الحياة يمكنهـا أن تكون لعبة بتبسيطهـا لقواعد يفهمها العامـةقواعد بسیطـة تضمن الوصـول لأفضل النتائج مما يجلعها أقرب لاستراتيجية  ومنهج لإدارة الحیـاة<br/> ولعبتنا هي لعبة يوم واحد وتتكرر كل يوم وقواعدها:<br/><br/><span className='leading-10 bg-[#FBD675] p-2'>استيقاظ باكر، صلاة، رياضة، تعلم، العمل على هدف</span><br/>هذه الأساسيـات الخمس كفيلـة بتبسيط الحيـاة وجعلهـا لعبـة إذا ما التزمـت بها تفـوز وإذا ما تهاونت تخسـر<br/><br/>   هذا النظـام تم تجربتـه على حیـاة عشـرات آلاف الشباب الذین قامـوا بمتابعـة حلقات ثائر على منصة یوتیوب والعمل بها<br/><br/>   ومنذ ثلاثة أعوام نمهد للشبـاب لتسهيل حياتهـم حتى وصلنا إلى خلق بيئة نقدم فيهـا بالمجـان أهـم علـوم هـذا العـصـر التكنولـوجيـة ليمـلك شبـابنـا مفاتيـح المستقبــل، ونغيـر بهـا حيـاة الأفـراد ليغـيروا بـدورهــم العـالــم بهذا نبني لك أسـاس يدفعـك للأمـام ويلتقطك عند السقـوط.</p> 
          </div>
        </div>
      </div>
      :"<div></div>";
     </div>
    </> 
  );
};

export default TheName;